export const AvailablePermissions = {
  ADMIN_VIEW: 'admin.view',
  ADMIN_CREATE: 'admin.create',
  ADMIN_UPDATE: 'admin.update',
  ADMIN_DELETE: 'admin.delete',

  USER_VIEW: 'user.view',
  USER_CREATE: 'user.create',
  USER_UPDATE: 'user.update',
  USER_DELETE: 'user.delete',
  USER_IMPERSONATE: 'user.impersonate',

  ROLE_VIEW: 'role.view',
  ROLE_CREATE: 'role.create',
  ROLE_UPDATE: 'role.update',
  ROLE_DELETE: 'role.delete',

  PRODUCT_VIEW: 'product.view',
  PRODUCT_CREATE: 'product.create',
  PRODUCT_UPDATE: 'product.update',
  PRODUCT_DELETE: 'product.delete',
  PRODUCT_VIEW_ALL: 'product.view.all',
  PRODUCT_CREATE_ALL: 'product.create.all',
  PRODUCT_UPDATE_ALL: 'product.update.all',
  PRODUCT_DELETE_ALL: 'product.delete.all',

  DELIVERY_VIEW: 'delivery.view',
  DELIVERY_CREATE: 'delivery.create',
  DELIVERY_UPDATE: 'delivery.update',
  DELIVERY_VIEW_ALL: 'delivery.view.all',

  PAYMENT_VIEW: 'payment.view',
  PAYMENT_CREATE: 'payment.create',
  PAYMENT_UPDATE: 'payment.update',
  PAYMENT_VIEW_ALL: 'payment.view.all',

  COLLECTION_VIEW: 'collection.view',
  COLLECTION_CREATE: 'collection.create',
  COLLECTION_UPDATE: 'collection.update',
  COLLECTION_VIEW_ALL: 'collection.view.all',

  CUSTOMER_VIEW: 'customer.view',
  CUSTOMER_CREATE: 'customer.create',
  CUSTOMER_UPDATE: 'customer.update',
  CUSTOMER_DELETE: 'customer.delete',
  CUSTOMER_VIEW_ALL: 'customer.view.all',

  CATEGORY_VIEW: 'category.view',
  CATEGORY_UPDATE: 'category.update',
  CATEGORY_CREATE: 'category.create',
  CATEGORY_DELETE: 'category.delete',

  CONDITION_VIEW: 'condition.view',
  CONDITION_CREATE: 'condition.create',
  CONDITION_UPDATE: 'condition.update',
  CONDITION_DELETE: 'condition.delete',

  DESIGNER_VIEW: 'designer.view',
  DESIGNER_CREATE: 'designer.create',
  DESIGNER_UPDATE: 'designer.update',
  DESIGNER_DELETE: 'designer.delete',

  ORDER_VIEW: 'order.view',
  ORDER_CREATE: 'order.create',
  ORDER_UPDATE: 'order.update',
  ORDER_DELETE: 'order.delete',
  ORDER_VIEW_ALL: 'order.view.all',

  ORDER_COURIER_VIEW: 'order_courier.view',
  ORDER_COURIER_CREATE: 'order_courier.create',
  ORDER_COURIER_UPDATE: 'order_courier.update',
  ORDER_COURIER_DELETE: 'order_courier.delete',

  SIZE_VIEW: 'size.view',
  SIZE_CREATE: 'size.create',
  SIZE_UPDATE: 'size.update',
  SIZE_DELETE: 'size.delete',

  STYLE_VIEW: 'styles.view',
  STYLE_CREATE: 'styles.create',
  STYLE_UPDATE: 'styles.update',
  STYLE_DELETE: 'styles.delete',

  STATUS_VIEW: 'status.view',
  STATUS_CREATE: 'status.create',
  STATUS_UPDATE: 'status.update',
  STATUS_DELETE: 'status.delete',

  PROCESS_STATUS_VIEW: 'process_status.view',
  PROCESS_STATUS_CREATE: 'process_status.create',
  PROCESS_STATUS_UPDATE: 'process_status.update',
  PROCESS_STATUS_DELETE: 'process_status.delete',

  PROCESS_TYPE_VIEW: 'process_type.view',
  PROCESS_TYPE_CREATE: 'process_type.create',
  PROCESS_TYPE_UPDATE: 'process_type.update',
  PROCESS_TYPE_DELETE: 'process_type.delete',

  PROVIDER_VIEW: 'provider.view',
  PROVIDER_CREATE: 'provider.create',
  PROVIDER_UPDATE: 'provider.update',
  PROVIDER_DELETE: 'provider.delete',

  CURRENCY_VIEW: 'currency.view',
  CURRENCY_CREATE: 'currency.create',
  CURRENCY_UPDATE: 'currency.update',
  CURRENCY_DELETE: 'currency.delete',

  COLOR_VIEW: 'color.view',
  COLOR_CREATE: 'color.create',
  COLOR_UPDATE: 'color.update',
  COLOR_DELETE: 'color.delete',

  WARDROBE_VIEW: 'wardrobe.view',
  WARDROBE_CREATE: 'wardrobe.create',
  WARDROBE_UPDATE: 'wardrobe.update',
  WARDROBE_DELETE: 'wardrobe.delete',

  FLAUNT_VIEW_EMAILS: 'flaunt.view.emails',

  INVENTORY_VIEW: 'inventory.view',
  INVENTORY_CREATE: 'inventory.create',
  INVENTORY_UPDATE: 'inventory.update',
  INVENTORY_DELETE: 'inventory.delete',

  COUPON_VIEW_ALL: 'coupon.view.all',
  COUPON_UPDATE_ALL: 'coupon.update.all',
  COUPON_CREATE_ALL: 'coupon.create.all',

  PRODUCT_PROCESS_STATUS_UPDATE_FULL: 'product.process_status.update.full',
  PRODUCT_PROCESS_STATUS_UPDATE_RESTRICTED: 'product.process_status.update.restricted',

  WALLET_UPDATE_ALL: 'wallet.update.all',
  WALLET_VIEW_ALL: 'wallet.view.all',

  CUSTOM_ATTRIBUTE_VIEW: 'custom_attribute.view',
  CUSTOM_ATTRIBUTE_CREATE: 'custom_attribute.create',
  CUSTOM_ATTRIBUTE_UPDATE: 'custom_attribute.update',
  CUSTOM_ATTRIBUTE_DELETE: 'custom_attribute.delete',

  CUSTOM_ATTRIBUTE_OPTION_CREATE: 'custom_attribute_option.create',
  CUSTOM_ATTRIBUTE_OPTION_UPDATE: 'custom_attribute_option.update',
  CUSTOM_ATTRIBUTE_OPTION_DELETE: 'custom_attribute_option.delete',
};
